import { useState } from "react"
import { getTokenLocal } from "../../../../helper/utils"
import { useResponseHandle } from "../../../hooks"
import { useNavigate } from "react-router-dom"
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import UserAPI from "../../../../api/user"

const userAPI = new UserAPI()
interface Props {
  open: boolean
  setOpen: any
  data: {
    name: string
    uid: string
    group_sk: any[]
    practice_sk: any[]
  }
  setData: any
  fetchUserDetails: any
}
const DeleteGroupDetail = (props: Props) => {
  const token = getTokenLocal()
  const navigate = useNavigate()
  const { open, setOpen, fetchUserDetails, data, setData } = props

  const [isLoading, setIsLoading] = useState(false)

  const handleClose = () => {
    setData({ name: "", uid: "", group_sk: [], practice_sk: [] })
    setOpen(false)
  }

  const handleDelete = async () => {
    setIsLoading(true)

    const response = await userAPI.removeGroupDetail(
      token,
      data.group_sk,
      data.practice_sk,
      data.uid,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      fetchUserDetails()
      setIsLoading(false)
      handleClose()
    } else {
      setIsLoading(false)
      navigate("/auth")
    }
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          borderBottom: "1px solid #e0e0e0",
          marginBottom: "1rem",
          display: "flex ",
          justifyContent: "space-between",
        }}
      >
        Remove
        <IconButton sx={{ mr: 1 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ borderBottom: "1px solid #e0e0e0", width: "500px" }}>
        <Typography
          sx={{
            textAlign: "center",
            marginBottom: "10px",
            // display: "flex",
            // justifyContent: "center",
            paddingY: "10px",
          }}
        >
          Are you sure you want to remove <b>{data?.name} </b>?
        </Typography>
      </DialogContent>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          padding: "20px",
        }}
      >
        <Button
          variant="outlined"
          fullWidth
          onClick={handleClose}
          sx={{ width: "fit-content", minWidth: "50px", paddingX: "40px" }}
        >
          Cancel
        </Button>
        <Button
          disabled={isLoading}
          variant="contained"
          fullWidth
          onClick={handleDelete}
          sx={{ width: "fit-content", minWidth: "50px", paddingX: "40px" }}
          startIcon={isLoading && <CircularProgress size="1.5rem" />}
        >
          Remove
        </Button>
      </Box>
    </Dialog>
  )
}

export default DeleteGroupDetail
